// Dependencias
import Swal, { SweetAlertOptions } from 'sweetalert2';

// Constat
import { OptionsMessages } from '../config/Messages.config';

// Configuracion de la libreria de alertas
export const alertConfigurations: SweetAlertOptions = {
  showDenyButton: true,
  confirmButtonText: OptionsMessages.SI,
  denyButtonText: OptionsMessages.NO,
  allowEscapeKey: true,
  buttonsStyling: false,
  customClass: {
    confirmButton: 'btn btn-primary mx-2 btn-lg',
    denyButton: 'btn btn-danger mx-2 btn-lg'
  }
};

// Configuraciones de la libreria para toast
export const toastConfiguration: SweetAlertOptions = {
  toast: true,
  position: 'bottom-right',
  showConfirmButton: false,
  timer: 1000 * 3,
  timerProgressBar: true,
  didOpen: (t) => {
    t.onmouseenter = Swal.stopTimer;
    t.onmouseleave = Swal.resumeTimer;
  }
};
